import { DebouncedInput } from "../../../components_new/debounce-input/debounce-input";
import { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import { Tab, Tabs } from "react-bootstrap";
import { ReportingContext } from "../../home/home";
import { PERMISSIONS } from "../../../common/constants";
import ColorPicker from "./color-picker";

const AddNewTags = ({dataObject, setDataObject, addWorkSpaceTag, setShowModal}) => {

  return(
    <>
      <div className="content-item">
            <label>Tag Name:</label>
            <div>
              <DebouncedInput value={dataObject["tagName"]} onChange={(v) => setDataObject((obj) => ({ ...obj, tagName: v }))} />
            </div>
          </div>

  <div className="content-item">
    <br></br>
            <div>
               <ColorPicker setDataObject={setDataObject} />
            </div>
          </div>
          <br></br>
          <Button variant="primary"  onClick={() => {
            addWorkSpaceTag()
      
            setShowModal(false)
            }}>
            Save Changes
          </Button>
          </>
  )
}

const TabTitle = ({ text, icon }) => {
  return (
    <div className="tab-symbol-wrapper">
      <span className="material-symbols-outlined tab-symbol-button">{icon}</span>
      <label className="tab-symbol-text">{text}</label>
    </div>
  );
};



const EditTags = ({dataObject, setDataObject, optionsWorksTag, deleteWorkSpaceTag, setShowModal, renameWorkSpaceTag, setShowDeleteModal, showDeleteModal}) => {

    const optionsTag = (arr) => {
    
  return arr.map(item => ({
    label: item.name,
    value: item.id,
    color: item.color
  }));
}

  return(
    <>
  <div className="content-item">
            <label>Select Workspace Tag:</label>
            <div>
               <Select value={dataObject["deleteWorkTag"]} options={optionsTag(optionsWorksTag)} onChange={(v) => setDataObject((obj) => ({ ...obj, deleteWorkTag: v, newName: v.label, tagColor: v.color}))} />
            </div>
          </div>

           <div className="content-item">
            <label>New Name:</label>
            <div>
               <input  style={{
          border: "1px solid #abababff",
          borderRadius: "8px",
          padding: "5px",
          fontSize: "16px",
          backgroundColor: "white",
          color: "#333",
          outline: "none",
        }}  value={dataObject["newName"]} onChange={(v) => setDataObject((obj) => ({ ...obj, newName: v.target.value }))} />
            </div>
            <br></br>
             <div>
               <ColorPicker initialColor={dataObject["tagColor"]} setDataObject={setDataObject} />
            </div>
          </div>
          <br></br>
           <Button variant="primary" disabled={dataObject["newName"].length > 0? false: true} onClick={() => {
            renameWorkSpaceTag()
            setDataObject((obj) => ({ ...obj, newName: [] }))
            setDataObject((obj) => ({ ...obj, deleteWorkTag: [] }))
            setShowModal(false)
            }}>
            Save Changes
          </Button>&nbsp;&nbsp;&nbsp;
          <Button variant="danger" disabled={dataObject["deleteWorkTag"].label? false: true}   onClick={() => {
            setShowDeleteModal(true)
            setShowModal(false)
            }}>
            Delete Selected Tag
          </Button>
          
          </>
  )
}

const DeleteModal = ({showModal, setShowModal, deleteWorkSpaceTag, setDataObject }) => {
  return(
    <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Tag</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           Are you sure you want to delete tag?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => {
            deleteWorkSpaceTag()
            setDataObject((obj) => ({ ...obj, deleteWorkTag: [] }))
            setDataObject((obj) => ({ ...obj, newName: [] }))
            setShowModal(false)
            }}>
            Yes
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
  )
}


export const ModalWorkSpaceTags = ({showModal, setShowModal, dataObject, setDataObject, addWorkSpaceTag, optionsWorksTag, deleteWorkSpaceTag, renameWorkSpaceTag}) => {
const { getWorkSpacePermissions } = useContext(ReportingContext);

const [showDeleteModal, setShowDeleteModal] = useState(false);

   const isUserCanAddNewTag = getWorkSpacePermissions()?.includes(PERMISSIONS["ADD_TAG"])
   const isUserCanEditTag = getWorkSpacePermissions()?.includes(PERMISSIONS["EDIT_TAG"])

  return(
    <>
    <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add WorkSpace Tags</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <Tabs defaultActiveKey="campaign" id="fill-tab-example" className="mb-3" fill>
          {/* <Tab eventKey="campaign" title={<TabTitle icon={"tune"} text={"Campaign"} />}>
            <CampaignSettings />
          </Tab> */}
         {isUserCanAddNewTag && <Tab eventKey="template" title={<TabTitle icon={"new_label"} text={"Add New Tag"} />}>
            <AddNewTags dataObject={dataObject} setShowModal={setShowModal} setDataObject={setDataObject} optionsWorksTag={optionsWorksTag} addWorkSpaceTag={addWorkSpaceTag}/>
          </Tab> }
         {isUserCanEditTag && <Tab eventKey="shared-user" title={<TabTitle icon={"edit_square"} text={"Edit Tag"} />}>
          <EditTags dataObject={dataObject} showDeleteModal={showDeleteModal} setShowDeleteModal={setShowDeleteModal} setDataObject={setDataObject} setShowModal={setShowModal}  optionsWorksTag={optionsWorksTag} deleteWorkSpaceTag={deleteWorkSpaceTag} renameWorkSpaceTag={renameWorkSpaceTag}/>
          </Tab> }
        </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <DeleteModal setDataObject={setDataObject} setShowModal={setShowDeleteModal} showModal={showDeleteModal} deleteWorkSpaceTag={deleteWorkSpaceTag}  />
      </>
  )
}
